<script setup>
  import { ref, onBeforeMount, computed } from "vue";
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  import { useDevicesStore } from "@/stores/devices";
  import { useAreasStore } from "@/stores/areas";

  const props = defineProps({
    sitesOptions : Array,
  });

  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const devicesStore = useDevicesStore();
  const areasStore = useAreasStore();
  let id = ref(null);
  let site = ref(null);
  let area = ref(null);
  let isLoadingAreas = ref(null);
  let areasOptions = ref([]);
  let isSubmitted = ref(false);
  let devicesIds = ref([]);
  const getModalInfo = computed(()=> uiStore.modalData);
  const getModalAction = computed(()=> uiStore.modalAction);
  const company_id = useCompanyStore().companyId;

  const changeSiteVal = () => {
    area.value = null
    areasOptions.value = [];
    if(site.value){
      isLoadingAreas.value = true;
      areasStore.fetchParentAreas({
        siteId :site.value.id,
        companyId : company_id,
      }).then((res) => {
        areasOptions.value = res?.data || [];
        isLoadingAreas.value = false;
      });
    }
  }

  const onSubmit = () => {
    isSubmitted.value = true;
    let data = {};
    let action = null;
    if(getModalAction.value == 'move_device'){
      action = 'moveDevice';
      data = {
        id : id.value,
        area_id: area.value.id,
        company_id: company_id,
      }

    }else if(getModalAction.value == 'mass_move_devices') {
      action = 'massMoveDevices';
      data = {
        devices : devicesIds.value,
        area_id: area.value.id,
        company_id: company_id,
      }
    }

    devicesStore[action](data)
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'move_device'){
      id.value = getModalInfo.value.id;
    }else if(getModalAction.value == 'mass_move_devices') {
      if(Array.isArray(getModalInfo.value)){
        getModalInfo.value.map((row) =>{
          devicesIds.value.push(row.id)
        });
      }
    }
  });
</script>

<template>
  <DModal v-if="['move_device', 'mass_move_devices'].includes(getModalAction)" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title>
      {{ getModalAction === 'mass_move_devices' ? 'Move Devices' : 'Move Device' }}
    </template>

    <template #body>
      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="site"
          inputId="site"
          :options="props.sitesOptions"
          optionLabel="name"
          dataKey="id"
          class="w-full"
          filter
          filterPlaceholder="Search by site name"
          :disabled="!props.sitesOptions.length"
          @change="changeSiteVal"
        />
        <label for="site">Site</label>
      </FloatLabel>

      <FloatLabel class="w-full md:w-14rem">
        <PDropdown
          v-model="area"
          inputId="area"
          :options="areasOptions"
          optionLabel="name"
          dataKey="id"
          class="w-full"
          filter
          filterPlaceholder="Search by area name"
          :disabled="!site || isLoadingAreas"
          :loading="isLoadingAreas"
        />
        <label for="area">Area</label>
      </FloatLabel>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!site || !area || isSubmitted" 
          @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Move <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
